<template>
	<section class="costompopup pop_sm1">
		<div class="middleBox  platfromBox"> 
			<div class="darkBG platfromBox_title p-3 mb-4">  
				<h4 class="mb-0"> {{$t('openTradingAccount')}}</h4>
				<feather class="close" @click="pageRedirectFunc('')" type="x"></feather>
			</div>
			<div class="selectPro text-center p-4">
				<a href="#" class="slect_platform creat-account" @click="pageRedirectFunc('/create-demo-account')">
					<div class="thumb">
						<img src="../../../../static/fxView/images/demo_account.svg" alt="Demo Account">
					</div>
					<h4> {{$t('createDemoAccount')}}</h4>
				</a>
				<a href="#" class="slect_platform" v-if="parseInt(get_user.step) <= 4 || parseInt(get_user.verified_status) != 1">
					<div class="thumb position-relative overflo-hidden">
						<img src="../../../../static/fxView/images/live_account.svg" alt="Live Account">

						<div class="overlapmsg">
							<p class="red">{{$t('Disabled')}}</p>
						</div>
					</div>
					<h4> {{$t('createLiveAccount')}}</h4>
				</a>
				<a href="#" class="slect_platform creat-account" @click="pageRedirectFunc('/create-live-account')" v-else> 
					<div class="thumb">
						<img src="../../../../static/fxView/images/live_account.svg" alt="Live Account">
					</div>
					<h4>{{$t('createLiveAccount')}}</h4>
				</a>
			</div>
			 
		</div>
	</section>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'steps',
		mixins: [fxViewMixins],
        data() {
            return {}
        },
		methods:{
			pageRedirectFunc(getData){
				if(getData == '/create-demo-account'){
					this.$trackEvent('CP+Dashboard+Open+Demo+Account');
				}else{
					this.$trackEvent('CP+Dashboard+Open+Live+Account');
				}
				this.$parent.showTab = ''
				if(getData != ''){ this.$router.replace(getData)  }
			}
		}
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingAccounts/platform_type.vue